import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { Backdrop, CircularProgress } from '../../utils/material-ui-core';

// import Wait from '../wait';

interface SavBackdropProps {
  open: boolean;
}

const SavBackdrop = ({ open }: SavBackdropProps) => {
  const pageStyles = LocalPageStyles();

  return (
    <Backdrop className={pageStyles.backdrop} open={open}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  })
);

export default SavBackdrop;
